import { getNotifPOFA } from "App/Component/layout/FixedAsset/Transaksi/DaftarPo/helpers";
import { getNotifReqFA } from "App/Component/layout/FixedAsset/Transaksi/DaftarRequestFixedAsset/helpers";
import { getNotifRekapTagihan } from "App/Component/layout/RekapTagihan/InputRekapTagihan/ui";
import {
  changeActiveMenu,
  changeActiveTab,
  changeNotifikasiCount,
  changeNotifikasiList,
  changePageProps,
  changeTabs,
  changeLoading,
  changePagePropsInputRekapTagihan,
} from "App/Component/layout/Wrapper/context/actions";
import { WrapperCtx } from "App/Component/layout/Wrapper/context/context";
import {
  instance4,
  RB_PENGAJUAN,
  RB_REQUEST,
  RT_INPUT_REKAP_TAGIHAN,
  WMS_FA_PENGAJUAN,
  WMS_FA_PO,
  WMS_FA_REQUEST,
} from "App/constants";
import { getUserName } from "App/utils/cookies";
import { defaultToastError, isNull, scrollToTop } from "App/utils/helpers";
import { useContext } from "react";

function useDispatchWrapper() {
  const { state, dispatch } = useContext(WrapperCtx);
  const tabs = state.wrapper_tabs;
  const isLoading = state.wrapper_loading;

  const handleClickMenu = (nav) => {
    const index = tabs.findIndex((e) => e.code === nav.code);

    if (tabs.length > 30) {
      tabs.shift();
    }

    if (index === -1) {
      const newTabs = [...tabs];
      dispatch(changeLoading(true));
      newTabs.push({
        code: nav.code,
        name: nav.name,
      });
      dispatch(changeTabs(newTabs));
      dispatch(changeActiveTab(nav.code));
      dispatch(changeLoading(false));
      scrollToTop();
    } else {
      dispatch(changeActiveTab(nav.code));
    }
  };

  const setNewNotif = async () => {
    try {
      const getNotif = await instance4.post("/notifikasi/notifikasi/list", {
        to_user_notifikasi: getUserName(),
        jumlah: 5,
        halaman: 1,
      });
      const res = getNotif.data;
      if (res.status === 200) {
        dispatch(changeNotifikasiList(res.data));
        dispatch(changeNotifikasiCount(res.count_notif));
      }
    } catch (error) {
      return defaultToastError(error?.response?.data?.message);
    }
  };

  const handleMoveTab = ({ kode = "", dataProps = "", nav = "" }) => {
    Promise.resolve()
      .then(() => {
        dispatch(changeActiveMenu(kode));
      })
      .then(() => {
        dispatch(changePageProps(dataProps));
        dispatch(changeActiveTab(kode));
        handleClickMenu(nav);
      });
  };

  const handleChangeActiveMenu = (kode_menu, nama_menu) => {
    dispatch(changeActiveTab(kode_menu));
    dispatch(changeActiveMenu(kode_menu));
    handleClickMenu({
      code: kode_menu,
      name: nama_menu,
    });
  };

  const handleMoveTabNotif = async (id, kode_menu, nama_menu, table_id) => {
    try {
      dispatch(changeLoading(true));
      const updateNotif = await instance4.post(
        "/notifikasi/notifikasi/update",
        {
          id,
        }
      );
      const res = updateNotif.data;
      if (res.status === 200) {
        const getProps = getDataProps(table_id, kode_menu);
        let dataProps = null;
        const nav = { code: kode_menu, name: nama_menu };
        await Promise.all([getProps]).then((responses) => {
          dataProps = responses[0];
          if (!isNull(dataProps)) {
            if (kode_menu === RT_INPUT_REKAP_TAGIHAN) {
              dispatch(changePagePropsInputRekapTagihan(dataProps));
              handleChangeActiveMenu(
                RT_INPUT_REKAP_TAGIHAN,
                "Input Rekap Tagihan"
              );
            } else {
              handleMoveTab({
                kode: kode_menu,
                dataProps: dataProps,
                nav: nav,
              });
            }
            setNewNotif();
            dispatch(changeLoading(false));
          } else {
            dispatch(changeLoading(false));
            defaultToastError("Data tidak ditemukan!");
          }
        });
      } else {
        dispatch(changeLoading(false));
        defaultToastError("Terjadi Kesalahan !");
      }
    } catch (error) {
      dispatch(changeLoading(false));
      defaultToastError(error?.response?.data?.message);
    }
  };

  return {
    state,
    dispatch,
    handleClickMenu,
    isLoading,
    handleMoveTabNotif,
    setNewNotif,
  };
}

export default useDispatchWrapper;

function getDataProps(id, kode_menu) {
  switch (kode_menu) {
    case WMS_FA_REQUEST:
      return getNotifReqFA({ id: id });
    case WMS_FA_PENGAJUAN:
      return getNotifReqFA({ id: id });
    case RB_REQUEST:
      return getNotifReqFA({ id: id });
    case RB_PENGAJUAN:
      return getNotifReqFA({ id: id });
    case WMS_FA_PO:
      return getNotifPOFA({ id: id });
    case RT_INPUT_REKAP_TAGIHAN:
      return getNotifRekapTagihan({ id: id });
    default:
      return null;
  }
}
